import React, { useEffect, useState  } from 'react';
import { LineChart } from '@mui/x-charts/LineChart';

const MainLineChart = ({bookings}) => {  
  return (
    <LineChart
      xAxis={[
        {
          data: bookings.map((book, index) => index+1),
          max: bookings.length
        }
      ]}
      yAxis={[{
          min:0,
          max:24,
          tickInterval: 2,
        }]
      }
      series={[
        {
          data: bookings.map(book => book.hoursOccupied),
          showMark: (params)=> params.value === 0 ? false : true,
        },
      ]}
      height={300}
    />
  );
}

export  { MainLineChart }